import { ACCESSIBLE_MUDULE_KEYS } from "../../constants/enum";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { WaitList } from "./waitlist";
import { WAIT_LIST_ROUTE } from "./WaitList.constant";

export const waitListRoute =[
    {
        path: WAIT_LIST_ROUTE,
        exact: true,
        element:  <AuthorizedRoute moduleIds={[ACCESSIBLE_MUDULE_KEYS.RESERVATION]}><WaitList/></AuthorizedRoute>
    },
]